export type ExtraFieldType = 'text' | 'number' | 'date';

export interface ExtraFieldTemplateEntry {
  fieldName: string;
  fieldType: ExtraFieldType;
}

export const EXTRA_FIELD_TEMPLATE: readonly ExtraFieldTemplateEntry[] = [
  { fieldName: 'texto1', fieldType: 'text' },
  { fieldName: 'texto2', fieldType: 'text' },
  { fieldName: 'date1', fieldType: 'date' },
  { fieldName: 'date2', fieldType: 'date' },
  { fieldName: 'amount1', fieldType: 'number' },
  { fieldName: 'amount2', fieldType: 'number' },
] as const;

export const EXTRA_FIELD_NAMES: readonly string[] = EXTRA_FIELD_TEMPLATE.map(
  (f) => f.fieldName,
);

export function getExtraFieldType(fieldName: string): ExtraFieldType | null {
  return EXTRA_FIELD_TEMPLATE.find((f) => f.fieldName === fieldName)?.fieldType ?? null;
}
